<template>
  <v-container fluid class="overflow-hidden">
    <nav v-if="isLogged">
      <div class="row bandeauTitre">
        <div class="col-xl-11 col-lg-10 col-md-10 col-sm-10 col-8">
          <span @click="version" class="text-left titre"><span class="autreLettreTitre">Money</span><span class="lettreTitre"><b>Allocate</b></span></span>
          <span v-if="!isHiddenVersion" id="version"> v0.0.1</span>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-2 col-4 iconDeconnexion">
          <span class="pseudo"><b>{{ getPseudo() }}</b></span>
          <span @click="logout" class="seDeconnecter">
            <i class="fas fa-sign-out-alt fa-2x logoutConnexion"></i>
          </span>
        </div>
      </div>
      <div id="action" class="row">
        <div id="ongletDashboard" @click='getComponentSelected("Dashboard")' class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 ongletSelection"><b>Tableau de bord</b></div>
        <div id="ongletManageInvoice" @click='getComponentSelected("ManageInvoice")' class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3"><b>Ajouter un facture</b></div>
        <div id="ongletManageEnvelope" @click='getComponentSelected("ManageEnvelope")' class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3"><b>Gérer les enveloppes</b></div>
        <div id="ongletSetting" @click='getComponentSelected("Setting")' class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3"><b>Paramétrage</b></div>
      </div>
    </nav>

    <keep-alive>
      <component v-bind:is="componentSelected"></component>
    </keep-alive>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import Dashboard from '@/components/Application/Dashboard.vue'
import ManageInvoice from '@/components/Application/ManageInvoice.vue'
import ManageEnvelope from '@/components/Application/ManageEnvelope.vue'
import Setting from '@/components/Application/Setting.vue'

export default {
  components: { Dashboard, ManageInvoice, ManageEnvelope, Setting },
  name: 'Navbar',
  data: () => {
    return {
      pseudo: '',
      isHiddenVersion: true,
      componentSelected: 'Dashboard',
      onglet: ['Dashboard', 'ManageInvoice', 'ManageEnvelope', 'Setting']
    }
  },

  computed: {
    ...mapGetters(['isLogged'])
  },

  methods: {
    getComponentSelected (component) {
      this.componentSelected = component

      $.each(this.onglet, function (index, value) {
        if ($('#onglet' + value).hasClass('ongletSelection')) {
          $('#onglet' + value).removeClass('ongletSelection')
        }
      })
      $('#onglet' + component).addClass('ongletSelection')
    },

    logout () {
      this.$store.dispatch('logout')
    },

    getPseudo () {
      return localStorage.pseudo
    },

    version () {
      this.isHiddenVersion = !this.isHiddenVersion
    }
  }
}
</script>
<style scoped>
  .bandeauTitre {
    background-color: #1BA678;
    color: cornsilk;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .titre {
    padding-left: 10%;
    font-size: 3vw;
    cursor: pointer;
  }

  .seDeconnecter {
    text-decoration: none;
    cursor: pointer;
    color: cornsilk;
  }

  .lettreTitre {
    color: #1B8EA6;
  }

  .logoutConnexion:hover {
    color: #1B8EA6;
  }

  .iconDeconnexion {
    margin: auto;
  }

  .pseudo {
    padding-left: 10px;
    padding-right: 10px;
    color: cornsilk;
  }

  #action {
    text-align: center;
    cursor: pointer;
  }

  .ongletSelection {
    background-color:#1B8EA6;
    color: cornsilk !important;
    border-width: 1px;
    border-color: #1B8EA6;
    border-style: solid;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  #ongletDashboard {
    color: #1B8EA6;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  #ongletManageInvoice {
    color: #1B8EA6;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  #ongletManageEnvelope {
    color: #1B8EA6;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  #ongletSetting {
    color: #1B8EA6;
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  @media screen and (max-width: 600px) {
    .titre {
      font-size: 8vw;
    }

    .fa-2x {
      font-size: 5vw;
    }

    .pseudo {
      font-size: 4vw;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1024px) {
    .titre {
      font-size: 4vw;
    }

    .fa-2x {
      font-size: 2.5vw;
    }

    .pseudo {
      font-size: 1.75vw;
    }
  }

  @media screen and (min-width: 1025px) {
    .titre {
      font-size: 2vw;
    }

    .fa-2x {
      font-size: 1.3vw;
    }
  }

  @media print {
    .seDeconnecter {
      display: none;
    }
    .autreLettreTitre {
      color: blueviolet;
    }

    .titre {
      font-size: 8vw;
    }

    .pseudo {
      color: blueviolet;
      font-size: 4vw;
    }
  }
</style>
